"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Moon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Moon = () => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z", fill: "none", stroke: "currentcolor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "16" }) })));
};
exports.Moon = Moon;
